import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Link from "@/utils/link";
import { PhoneIcon, ChevronLeftIcon, ChevronDownIcon } from "@heroicons/react/solid";

import Menu from "@/ui/Menu";

import PurpleDoorLogoHorizontal from "../Logo/PurpleDoorLogoHorizontal";
import HomeHeaderMenu from "./HomeHeaderMenu";
import { topAreas } from "./topAreas";

import { host } from "@/utils/config";
import { PdfPhoneClick } from "@/components/community/PhoneReveal";

export const links = [
    { link: "/", label: "All" },
    { link: "/independent-living", label: "Independent" },
    { link: "/assisted-living", label: "Assisted" },
    { link: "/memory-care", label: "Memory" },
];

export const LinkItem = ({ link, label }) => {
    return (
        <div className="text-black font-bold uppercase hover:text-primary-400">
            <Link href={link}>
                <a>{label}</a>
            </Link>
        </div>
    );
};

const HomeHeader = ({ fixed }) => {
    // get the current path
    const router = useRouter();
    const path = router.pathname;

    const isHomePage = path === "/";

    const phoneCta = (
        <div className="flex items-center gap-4">
            <span className="hidden sm:block text-sm sm:text-2xl font-bold font-headline">
                Talk to an Assisted Living Counselor
            </span>

            <span className="block sm:hidden text-sm sm:text-2xl font-bold font-headline">
                Call Us
            </span>

            <a
                href="tel:6127877533"
                className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 rounded-full px-3 py-1"
                onClick={PdfPhoneClick}
            >
                <div className="w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center">
                    <PhoneIcon className="w-4 h-4 text-white" />
                </div>
                <span className="text-sm sm:text-lg font-bold text-gray-700">
                    612-787-7533
                </span>
            </a>
        </div>
    );

    return (
        <>
            {/* Top purple banner */}
            {!isHomePage ? (
                <div
                    className={`z-50 w-full h-12 sm:h-16 bg-primary-500 flex items-center justify-between text-white ${
                        fixed ? "fixed" : "static"
                    }`}
                >
                    <div className="flex items-center px-4">
                        <button
                            onClick={() => router.back()}
                            className="p-1 hover:bg-primary-400 rounded-full"
                        >
                            <ChevronLeftIcon className="w-8 h-8" />
                        </button>
                    </div>
                    {phoneCta}
                    <div className="w-10"></div>
                </div>
            ) : (
                <div
                    className={`z-50 w-full h-12 sm:h-16 bg-primary-500 flex items-center justify-center text-white ${
                        fixed ? "fixed" : "static"
                    }`}
                >
                    {phoneCta}
                </div>
            )}

            <div
                id="purple-door-header"
                className={`z-50 w-full bg-gray-50 border-b-2 border-gray-100 shadow ${
                    fixed ? "fixed top-12 sm:top-16" : "static"
                }`}
            >
                <nav className="h-12 sm:h-16 flex justify-between items-center">
                    <div className="w-64 flex items-center">
                        <Link href="/">
                            <a className="-ml-10 sm:ml-2 scale-75 sm:scale-100">
                                <PurpleDoorLogoHorizontal />
                            </a>
                        </Link>
                    </div>

                    <div className="flex items-center sm:gap-2">
                        <div className="hidden sm:flex items-center gap-1">
                            {/*<Link href={"/about-us"}>
                                <a className="px-4 py-2 text-primary-500 font-bold  rounded hover:bg-gray-200">
                                    About Us
                                </a>
                            </Link>*/}

                            <Link href={"/resources"}>
                                <a className="px-4 py-2 text-primary-500 font-bold  rounded hover:bg-gray-200">
                                    Resources
                                </a>
                            </Link>

                            <Menu placement="bottom-start">
                                <Menu.Button>
                                    <div className="px-4 py-2 flex items-center text-primary-500 font-bold rounded hover:bg-gray-200">
                                        Top Areas
                                        <ChevronDownIcon className="ml-1 w-5 h-5" />
                                    </div>
                                </Menu.Button>

                                <Menu.Items
                                    className={`z-10 w-56 bg-gray-50 
                                                 rounded overflow-hidden shadow-lg ring-1 ring-black ring-opacity-5
                                                 border border-gray-300 focus:outline-none`}
                                >
                                    {topAreas.map((area) => (
                                        <Menu.Item key={area.url} className="w-full">
                                            <Link href={"/" + area.url}>
                                                <a className="w-full flex items-center px-4 py-2 hover:bg-gray-200 text-left">
                                                    {area.name}
                                                </a>
                                            </Link>
                                        </Menu.Item>
                                    ))}
                                </Menu.Items>
                            </Menu>

                            {/*<Link href={"/how-it-works"}>
                                <a className="px-4 py-2 text-primary-500 font-bold  rounded hover:bg-gray-200">
                                    How It Works
                                </a>
                            </Link>*/}

                            <Link href={host + "community-portal"}>
                                <a className="px-4 py-2 text-primary-500 font-bold  rounded hover:bg-gray-200">
                                    Manage My Listing
                                </a>
                            </Link>
                        </div>

                        <HomeHeaderMenu />
                    </div>
                </nav>
            </div>
        </>
    );
};

export default HomeHeader;
